// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TIxI","title":"styles_title__2bMIx"};